/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from "@angular/common";
import {
    booleanAttribute,
    Component,
    computed,
    input,
    model,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Size } from "../../common/types";
import { Hint } from "../../hint/hint.component";
import { Label } from "../../label/label.component";
import { Checkbox } from "../checkbox.component";

export type CheckboxOption = {
    label: string;
    value: string;
    disabled?: boolean;
    description?: string;
};

@Component({
    selector: "app-checkbox-group",
    templateUrl: "./checkbox-group.component.html",
    imports: [Checkbox, Label, Hint, CommonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckboxGroup,
            multi: true,
        },
    ],
})
export class CheckboxGroup implements ControlValueAccessor {
    required = input<boolean, string>(false, { transform: booleanAttribute });
    label = input<string>();
    $options = input.required<string[] | CheckboxOption[]>({
        alias: "options",
    });
    options = computed(() => {
        return this.$options().map((option) => {
            if (typeof option === "string") {
                return {
                    label: option,
                    value: option,
                };
            }
            return option;
        });
    });
    value = model<any[]>();
    size = input<Size>();
    hint = input<string>();
    direction = input<"vertical" | "horizontal">("horizontal");
    wrap = input<boolean, string>(false, { transform: booleanAttribute });
    justOneSelect = input<boolean>(false);

    writeValue(obj: any): void {
        this.value.set(obj);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {}

    onChange = (ev?: any) => {};
    onTouched = () => {};

    handleValueChange(checked: boolean, val: any) {
        const current = this.value() || [];

        if (this.justOneSelect()) {
            // 단일 선택 시 다른 값 체크 해제
            const updated = current.map((v) => {
                if (v === val) {
                    return val;
                } else {
                    return undefined;
                }
            });
            this.value.set(updated.filter((v) => v !== undefined));
            this.onChange(updated.filter((v) => v !== undefined));
        } else {
            if (checked) {
                // 중복 없이 추가
                if (!current.includes(val)) {
                    this.value.set([...current, val]);
                    this.onChange(this.value());
                }
            } else {
                // 체크 해제 시 해당 값 제거
                const updated = current.filter((v) => v !== val);
                this.value.set(updated);
                this.onChange(updated);
            }
        }
    }
}
